import * as React from "react";
import { useCallback, useState } from "react";
import { useAppContext } from "../../Contexts/AppContext";
import { Popup, PopupHeader, PopupBody, PopupFooter } from "../../Popups/Popup";
import { CloseButton } from "../../Elements/CloseButton";
import { useMapContext } from "../../Contexts/MapContext";
import { IPopupConfig } from "../config";
import "./NewsPopup.scss";

export interface IPopup extends IPopupConfig {
    seen: boolean;
}

export const NewsPopup = (): JSX.Element => {
    const { isMobile } = useAppContext();
    const { configA } = useMapContext();

    const hasNewsPopup = () => {
        const storedPopupsJson = localStorage.getItem("popups");
        const storedPopups = storedPopupsJson && (JSON.parse(storedPopupsJson) as IPopup[]);

        const popups = [] as IPopup[];

        for (const popup of configA.popup) {
            let seen = false;
            if (storedPopups) {
                const sameStoredPopup = storedPopups.find(
                    (storedPopup) => storedPopup.id === popup.id && storedPopup.version === popup.version
                );
                if (sameStoredPopup) {
                    seen = sameStoredPopup.seen;
                }
            }
            popups.push({ ...popup, seen });
        }

        return popups;
    };

    const [popups, setPopups] = useState<IPopup[]>(hasNewsPopup());

    const closePopup = useCallback(
        (id: string) => {
            if (!popups) {
                return;
            }
            const newPopups = [...popups];
            const currentPopup = newPopups.find((popup) => popup.id === id);
            if (currentPopup) {
                currentPopup.seen = true;
                localStorage.setItem("popups", JSON.stringify(newPopups));
                setPopups(newPopups);
            }
        },
        [popups]
    );

    const currentPopup = popups.find((popup) => !popup.seen);

    return (
        <>
            {popups?.length && currentPopup ? (
                <Popup
                    id={"news-popup"}
                    sameContainer={true}
                    isMobile={false}
                    hasBackdrop={true}
                    className={"relative"}
                >
                    <PopupHeader isMobile={isMobile}>
                        <div></div>
                        <CloseButton onClose={() => closePopup(currentPopup.id)}></CloseButton>
                    </PopupHeader>
                    <PopupBody isMobile={isMobile}>
                        <div dangerouslySetInnerHTML={{ __html: currentPopup.text }}></div>
                    </PopupBody>
                    <PopupFooter isMobile={isMobile} />
                </Popup>
            ) : null}
        </>
    );
};
